export function thinkers50CTA() {
    $('.main').append($('.section-cta-accordion'));
}



// WEBPACK FOOTER //
// ./assets/js/modules/thinkers50CTA.js